import { Dispatch } from "../../config/controller";
import { UserAuth } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";


export interface StatusAppState extends StateProps<any> {
    credencial:UserAuth
    start:boolean
    versao:string
}


export interface StatusAppActions extends Dispatch<any> {
    startApp:()=>any
    login:(login:string,pass:string)=>any
    logOut:()=>any
}

const model = new Model<any,StatusAppState>("statusapp");


export const initialValueStatusAppState:StatusAppState = {
    ...model.getInititalValueState(),
    credencial: {} as UserAuth,
    start:false,
    versao:"0.1.2"
}


